const $ = jQuery;

const initUsefulLinks = () => {
  const $usefullLinksPop = $('.menu--usefullinks');
  const $usefullLinksPopContent = $usefullLinksPop.find('.menu');;
  const $trigger = $('.js-useful-links');
  const $imgHeader = $('<h2 class="img-header"></h2>');
  const $close = $('<span class="close"></span>');
  const $usefullLinks = $usefullLinksPopContent.find('.menu-item');
  $imgHeader.prependTo($usefullLinksPopContent);
  $close.prependTo($usefullLinksPopContent);
  // wrap image within link element
  $usefullLinks.each(function(i, li) {
    const $li = $(li);
    const $link = $li.find('a');
    const $extraField = $li.find('.menu_link_content');
    const text = $link.text().trim();
    $link.text('');
    $extraField.appendTo($link);
    // wrap link element's text content within extra span for easier styling
    $(`<span>${ text }</span>`).appendTo($link);
  });
  // event bounding
  $trigger.on('click', () => { $usefullLinksPop.addClass('is-open') });
  $close.on('click', () => { $usefullLinksPop.removeClass('is-open') });
  $usefullLinksPop.on('click', (e) => {
    if (e.target.tagName.toLowerCase() === 'nav') {
      $usefullLinksPop.removeClass('is-open');
    }
  });
}

export default initUsefulLinks
